import React from 'react'

const BookTour = () => {
  return (
    <div className='book-tour'>
      <h1 className='title'>Book This Tour</h1>
      <h3 className='subtitle'>Starting Price $2500</h3>
    </div>
  )
}

export default BookTour
